
import PropTypes from 'prop-types'
import { Checkbox, Col, Row } from 'antd'
import { useField } from 'formik'
import { has } from 'lodash'

import Item from './Item'

const { Group } = Checkbox

export default function MultipleCheckboxes({
  label = undefined,
  options = [],
  helperText = undefined,
  layout = undefined,
  ...rest
}) {
  const [field, { error, touched }, { setValue }] = useField(rest)
  const { wrapperCol, labelCol, labelAlign } = rest
  const hasError = Boolean(touched && error)
  const defaultValues = field.value || []

  return (
    <Item
      label={label}
      hasFeedback={false}
      validateStatus={hasError ? 'error' : ''}
      help={hasError && error}
      helperText={helperText}
      wrapperCol={wrapperCol}
      labelCol={labelCol}
      labelAlign={labelAlign}
      layout={layout}
    >
      <Group
        onChange={setValue}
        defaultValue={defaultValues}
        style={{ width: '100%' }}
      >
        <Row>
          {options.map(option => (
            <Col xs={24} md={6} key={has(option, 'value') ? option.value : option}>
              <Checkbox value={has(option, 'value') ? option.value : option}>
                {has(option, 'label') ? option.label : option}
              </Checkbox>
            </Col>
          ))}
        </Row>
      </Group>
      <style>{`
        .ant-checkbox-group .ant-checkbox-wrapper {
          margin-left: 0;
        }
      `}</style>
    </Item>
  )
}

MultipleCheckboxes.propTypes = {
  label: PropTypes.string,
  type: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.string),
  helperText: PropTypes.string,
  layout: PropTypes.string,
}
